<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <layout-no-padding>
            <page-title :routeProps="routeProps"></page-title>
          </layout-no-padding>
        </div>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'

// MIXINS
import RouteProps from '@/services/mixins/routeProps'

export default {
  mixins: [RouteProps],
  data() {
    return {
      addDialog: false,
      loading: false,
    }
  },
}
</script>

<style scoped>
.overlap-fab {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>


